"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6598],{

/***/ 6598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ AdsEvents; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

function AdsEvents(param) {
    var segmentacoes = param.segmentacoes;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var googletag = window.googletag;
        googletag.cmd.push(function() {
            if (typeof segmentacoes !== "undefined" && (segmentacoes === null || segmentacoes === void 0 ? void 0 : segmentacoes.length) > 0) {
                segmentacoes.forEach(function(seg) {
                    if (typeof (seg === null || seg === void 0 ? void 0 : seg.valor) === "string") {
                        googletag.pubads().setTargeting(seg.chave, seg === null || seg === void 0 ? void 0 : seg.valor);
                    } else {
                        var ref;
                        seg === null || seg === void 0 ? void 0 : (ref = seg.valor) === null || ref === void 0 ? void 0 : ref.forEach(function(subseg) {
                            googletag.pubads().setTargeting(seg.chave, subseg);
                        });
                    }
                });
            }
            googletag.enableServices();
        }, []);
    }, [
        segmentacoes
    ]);
    return null;
}


/***/ })

}]);